
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 2.667a13.333 13.333 0 100 26.666 13.333 13.333 0 000-26.666zm0 24a10.666 10.666 0 110-21.333 10.666 10.666 0 010 21.333zm0-18.668a1.333 1.333 0 00-1.333 1.334v8a1.333 1.333 0 002.666 0v-8A1.333 1.333 0 0016 7.999zm.513 13.429c.162.068.31.167.434.292.121.127.216.276.28.44.068.16.104.332.106.506a1.334 1.334 0 11-2.666 0c.002-.174.038-.346.106-.506.064-.164.159-.313.28-.44a1.332 1.332 0 011.46-.292z","fill":"currentColor"}})])
          )
        }
      }
    